import {GET_FillProgramId,GET_FillExamType} from '../constants/ActionTypes'

const INIT_STATE = {
    ProgramId: null,
    Message1:''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillProgramId:
            return {
                ProgramId: action.body,
                Message1:action.Scrumsg
              
            }
           

        default:
            return state;
    }
}